export function formatDate(s: string): string {
  try {
    const d = new Date(s + 'T00:00:00');
    return d.toLocaleDateString('th-TH', { day: 'numeric', month: 'short' });
  } catch {
    return s;
  }
}

/** ความสูงเสา streak แบบคงที่ต่อ index (ไม่ใช้ Math.random) */
export function streakBarHeight(index: number, total: number): number {
  const t = total <= 1 ? 0.5 : index / (total - 1);
  return Math.round(12 + t * 16 + ((index * 7) % 5));
}
